<!--  -->
<template>
  <div class="img-text">
      <tem-head :globalConfig='globalConfig' v-if="temData.title" :text="temData.title" />
      <div class="card-list" :style="setStyle('main','color')">
        <Card v-for="(item, i) in temData.imageTextItemList" :key="i" :info="item"  />
      </div>
  </div>
</template>

<script>
import TemHead from '@/components/TemHead'
import Card from '@/components/Card'
import { mapState } from 'vuex'
import {setColor} from '../../utils/style'
export default {
  props: {
    temData: {
      type: Object
    }
  },
  components: {
    TemHead,
    Card
  },
  computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
    }),
  },
  methods:{
    setStyle(key, type) {
      return setColor(this.globalConfig, key, type);
    },
  }
}

</script>
<style lang='less' scoped>
.card-list {
  // margin-top: 56px;
  width: 1100px;
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;
  flex-wrap: wrap;
}
</style>